import React, { useState } from 'react'
import { D3RadialBar } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import {
    ComparisonViewWrap,
    Title, HeadingButton
} from './style'

const PercentSplit = (props) => {
  const { isPPTModalActive } = useGlobalStore()
  const [expand, setExpand] = useState(false)
  
  const {data, SegmentType, id} = props?.data?.[0]
  const data2 = data?.filter(d => d.SegmentName != 'NA')?.map(d => ({name: d.SegmentName, value: d.SegmentValue})) || []
  const data3 = data?.filter(d => d.SegmentName != 'NA')?.map(d => ({name: d.SegmentName, value: d.SegmentValue})) || []
  let width = window.innerWidth - 650
  if(width<700) width=700

  // console.log('isPPTModalActive===========', isPPTModalActive, data2, data3)

  return (
    <>
      {isPPTModalActive 
      ? <D3RadialBar width="1000" height="450" items={data3} innerRadius="20%" outerRadius="90%" id={id} />
      : <ComparisonViewWrap className={expand ? 'expanded' : 'collapsed'}>
          <HeadingButton onClick={() => setExpand(!expand)}>
            <Title>{SegmentType}</Title>
            <button className='button'></button>
          </HeadingButton>
          <D3RadialBar width={width} height="450" items={data2} innerRadius="20%" outerRadius="90%" id={id} />
        </ComparisonViewWrap>
      }
    </>
  )
}

export default PercentSplit
